<template>
	<div id="app">
		<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0,user-scalable=0" />
		<router-view style="width: 100%;"></router-view>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
export default {
	name: 'app',
	methods: {
		...mapActions({
			getTheme: 'theme/getTheme'
		})
	},
	created() {
		this.getTheme({}).then();
	}
};
</script>

<style lang="scss">
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	// height: 100vh;
}
.flex {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
}
.space-between {
	justify-content: space-between;
}
.text-center {
	text-align: center;
}
.text-left {
	text-align: left;
}
.text-right {
	text-align: right;
}
.color-white {
	color: #ffffff;
}
.el-container:first-child {
	height: 100%;
}
.transition-box {
	margin-bottom: 10px;
	width: 200px;
	height: 100px;
	border-radius: 4px;
	background-color: #409eff;
	text-align: center;
	color: #fff;
	padding: 40px 20px;
	box-sizing: border-box;
	margin-right: 20px;
}
.el-row {
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}
.el-col {
	border-radius: 4px;
}
.bg-purple-dark {
	background: #99a9bf;
}
.bg-purple {
	background: #d3dce6;
}
.bg-purple-light {
	background: #e5e9f2;
}
.grid-content {
	border-radius: 4px;
	min-height: 36px;
}
.row-bg {
	padding: 10px 0;
	background-color: #f9fafc;
}
.el-header,
.el-footer,
.el-aside {
	background-color: #141c23;
	color: #ffffff;
	line-height: 60px;
}
.el-menu-item.is-active {
	border-right: 3px solid #ffd04b;
}
.login {
	background: url(./assets/backimg.jpg);
	background-size: 100% auto;
}
.el-form-item__label {
	color: #000000;
}

/* @media screen and (max-width:1300px) {
	aside{
		display: none !important;
	}
	.login{
		background: url(./assets/backimg.jpg);
		background-size: 100% 100%;
	}
}
@media screen and (min-width:1301px) {
	footer{
		display: none !important;
	}
	.login{
		background: url(./assets/backimg.jpg);
		background-size: 100% auto;
	}
} */
.el-dialog__body {
	overflow-y: scroll;
}
.color-green {
	color: green;
}
.color-red {
	color: #ff2f4b;
}
.el-dropdown {
	margin: 0 10px;
}
.edui-toolbar {
	line-height: 20px;
}
.el-divider {
	/* // background-color: #3cacf0; */
	.el-divider__text {
		color: #458efc;
		font-size: 16px;
	}
}
.color-blue {
	color: #409eff !important;
}
.upfile {
	position: relative;
	width: 150px;
	height: 150px;
	.delicon {
		position: absolute;
		width: 100%;
		height: 30px;
		left: 0;
		top: 0;
		background: rgba($color: #000000, $alpha: 0.3);
		.el-icon-delete {
			color: #fff;
			cursor: pointer;
			font-size: 20px;
			&:hover {
				color: red;
			}
		}
	}
}
</style>

